import { render, staticRenderFns } from "./SkuDetail.vue?vue&type=template&id=a576c5ec&scoped=true"
import script from "./SkuDetail.vue?vue&type=script&lang=js"
export * from "./SkuDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a576c5ec",
  null
  
)

export default component.exports